"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _formData = _interopRequireDefault(require("form-data"));

var _errors = require("./errors");

var validFeedSlugRe = /^[\w]+$/;
var validUserIdRe = /^[\w-]+$/;
/*
 * Validate that the feedSlug matches \w
 */

function validateFeedSlug(feedSlug) {
  if (!validFeedSlugRe.test(feedSlug)) {
    throw new _errors.FeedError("Invalid feedSlug, please use letters, numbers or _: ".concat(feedSlug));
  }

  return feedSlug;
}
/*
 * Validate the userId matches \w
 */


function validateUserId(userId) {
  if (!validUserIdRe.test(userId)) {
    throw new _errors.FeedError("Invalid userId, please use letters, numbers, - or _: ".concat(userId));
  }

  return userId;
}

function rfc3986(str) {
  return str.replace(/[!'()*]/g, function (c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
  });
}

function isReadableStream(obj) {
  return obj !== null && (0, _typeof2.default)(obj) === 'object' && typeof obj._read === 'function';
}
/*
 * Validate that the feedId matches the spec user:1
 */


function validateFeedId(feedId) {
  var parts = feedId.split(':');

  if (parts.length !== 2) {
    throw new _errors.FeedError("Invalid feedId, expected something like user:1 got ".concat(feedId));
  }

  var _parts = (0, _slicedToArray2.default)(parts, 2),
      feedSlug = _parts[0],
      userId = _parts[1];

  validateFeedSlug(feedSlug);
  validateUserId(userId);
  return feedId;
}

function addFileToFormData(uri, name, contentType) {
  var data = new _formData.default();
  var fileField;

  if (isReadableStream(uri)) {
    fileField = uri;
  } else if (uri && uri.toString && uri.toString() === '[object File]') {
    fileField = uri;
  } else {
    fileField = {
      uri: uri,
      name: name || uri.split('/').reverse()[0]
    };
    if (contentType != null) fileField.type = contentType;
  }

  data.append('file', fileField);
  return data;
} // TODO: refactor and add proper types


function replaceStreamObjects(obj) {
  // @ts-expect-error
  if (Array.isArray(obj)) return obj.map(function (v) {
    return replaceStreamObjects(v);
  }); // @ts-expect-error

  if (Object.prototype.toString.call(obj) !== '[object Object]') return obj; // @ts-expect-error

  if (typeof obj.ref === 'function') return obj.ref();
  var cloned = {};
  Object.keys(obj).forEach(function (k) {
    // @ts-expect-error
    cloned[k] = replaceStreamObjects(obj[k]);
  }); // @ts-expect-error

  return cloned;
}

var _default = {
  validateFeedId: validateFeedId,
  validateFeedSlug: validateFeedSlug,
  validateUserId: validateUserId,
  rfc3986: rfc3986,
  isReadableStream: isReadableStream,
  addFileToFormData: addFileToFormData,
  replaceStreamObjects: replaceStreamObjects
};
exports.default = _default;